/** @file Route store: the current shell route, written only by navigate and listenHistory. */
import { createStore } from 'zustand/vanilla';
import type { Route } from '../shell/router/parseRoute';

/** Wrapped in an object so zustand can merge updates. */
export interface RouteState {
  route: Route;
}

/** Starts at the projects page until listenHistory reads the address bar. */
export const routeStore = createStore<RouteState>()(() => ({ route: { name: 'projects' } }));
